import {leftArrow, rightArrow} from './arrows.js'

const nav = imagePath => `<img src="${imagePath}" width="14" />`

export default [nav(leftArrow), nav(rightArrow)]